import React, {FC} from 'react';
import {ElementWrapper} from '../element-wrapper/element-wrapper.component';

import {ReactComponent as Arrow} from '../../assets/arrow.svg';

import {useNavigate} from 'react-router-dom';
import {DateTimeDisplay} from '../date-time-display/date-time-display.component';
import {AlertTypeIndicator} from '../alert-type-indicator/alert-type-indicator.component';
import { UnitDetail } from '../../services/api/models/UnitDetail';
import { ReportDateTimeDisplay } from '../report-comunicate-date-display/report-communicate-date-display.component'

type Props = {
  unit: UnitDetail;
  searchFilter?: string;
};

export const VehicleListItem: FC<Props> = ({unit, searchFilter}) => {
  const navigate = useNavigate();

    const loadUnit = () => {
    localStorage.removeItem("currentPage");
    navigate(`/units/${unit.id}`);
  };


  return (
    <div onMouseDown={loadUnit} className="cursor-pointer">
      <ElementWrapper>
        <div className="flex flex-1 flex-row items-center">
          <AlertTypeIndicator alertType={unit.alertStatus} />
          <div className="flex flex-col flex-1 justify-center gap-1">
                      <h3 className="overflow-hidden font-bold">{getHighlightedText(unit.unitName || '', searchFilter || '')}</h3>
                      {unit.lastCommunication && <ReportDateTimeDisplay registration={unit.registration} isGsm={unit.lastKnownLocation?.locationType} reportDate={unit.lastUpdate} communicationDate={unit.lastCommunication} useLighterDataFont />}
          </div>
          <Arrow className="cursor-pointer" />
        </div>
      </ElementWrapper>
    </div>
  );
};

const getHighlightedText = (text:string, highlight:string) => {
  if (!highlight) { 
    return text;
  }
  const parts = text.split(new RegExp(`(${escapeReplacement(highlight)})`, 'gi'));
  return <span>{parts.map((part, i) => part.toLowerCase() === highlight.toLowerCase() ? <mark key={i} className=' bg-trak-yellow'>{part}</mark> : part)}</span>;
}

const escapeReplacement = (s:string) => {
  return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}